module.exports = __webpack_public_path__ + "static/img/weibo-code.df72350.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/weibo-code.jpg
// module id = PbrJ
// module chunks = 0